import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, IonFooter } from '@ionic/react'
import { CouponItem, CouponDetail, Empty, TextTipAlert, Header } from '@cps'
import { memberMobx, themeMobx, authConfigMobx } from '@mobxStore'
import { ddayjs } from '@dt/fe-utils'
import { modalLayer, useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import PromoCode from '../components/promoCode'
import CouponsGet from '../couponsGet'
import './index.scss'

import noCouponImg from '@img/no-coupon.png'

interface IProps extends IPage, RouteComponentProps { }

const CouponPage: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { type } = match.params as any
  const { getMemberCoupons, redeemCouponsByCode, getUnacquiredCoupons, unacquiredCoupons, couponListForUse } = memberMobx
  const [cashCoupon, setCashCoupon] = useState<any[]>([])
  const [orderCoupon, setOrderCoupon] = useState<any[]>([])
  const [itemCoupon, setItemCoupon] = useState<any[]>([])
  const [notActiveCoupon, setNotActiveCoupon] = useState<any[]>([])
  const [couponType, setCouponType] = useState<'my' | 'get'>('my')
  const handleGo = (path: string) => {
    history.push(path)
  }
  const goBack = () => {
    mktController.goBack(history)
  }
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'use', couponInfo: data })
  }
  const getPromoCode = () => {
    modalLayer(PromoCode).then((code: any) => {
      if (code) {
        redeemCouponsByCode(code).then(() => {
          getTipAlert(i18n.t('mkt.redeem.succRedeem'), i18n.t('mkt.coupon.redeemCouponSucc'))
          getMemberCoupons()
        }).catch((error) => {
          let text = i18n.t('mkt.coupon.redeemFail4')
          if (error.code === 5004) {
            text = i18n.t('mkt.coupon.redeemFail1')
          } else if (error.code === 5005) {
            text = i18n.t('mkt.coupon.redeemFail2')
          } else if (error.code === 5003) {
            text = i18n.t('mkt.coupon.redeemFail5')
          } else if (error.code === 5006) {
            text = i18n.t('mkt.coupon.redeemFail3')
          } else if (error.code === 5008) {
            text = i18n.t('mkt.coupon.redeemFail6')
          }
          getTipAlert(i18n.t('mkt.coupon.redeemFail'), text)
        })
      }
    }).catch(() => { })
  }
  const getTipAlert = (title: string, des: string) => {
    modalLayer(TextTipAlert, {
      title,
      des
    }).catch(() => { })
  }
  // Component Effect
  useIonViewWillEnter(() => {
    getMemberCoupons()
    getUnacquiredCoupons()
    if (type) setCouponType(type)
  }, [])
  useEffect(() => {
    setCashCoupon(couponListForUse.filter((item: any) => item.type === 'cash' && ddayjs(item.startTime).valueOf() <= Date.now()))
    setOrderCoupon(couponListForUse.filter((item: any) => (item.type === 'order' || item.type === 'designate' || item.type === 'ladder' || item.type === 'express') && ddayjs(item.startTime).valueOf() <= Date.now()))
    setItemCoupon(couponListForUse.filter((item: any) => item.type === 'item' && ddayjs(item.startTime).valueOf() <= Date.now()))
    setNotActiveCoupon(couponListForUse.filter((item: any) => ddayjs(item.startTime).valueOf() > Date.now()))
  }, [couponListForUse])
  return (
    <IonPage className='my-coupon-page'>
      <Header onBack={goBack} className='my-coupon-header'>
        <div className={couponType === 'my' ? 'title' : 'desc'} onClick={() => setCouponType('my')}>{i18n.t('mkt.coupon.myCoupon')} ({couponListForUse.length}) </div>
        <div className={`coupon-left ${couponType === 'get' ? 'title' : 'desc'}`}>
          {
            !!unacquiredCoupons.length &&
              <div data-cypid='mmgToGetCoupon' className='coupon-get' onClick={() => setCouponType('get')}>
                <span>{i18n.t('mkt.coupon.couponsCanGet')}</span>
                <span className='coupon-get-tip'></span>
              </div>
          }
        </div>
        <div data-cypid='mmgToGiveCoupon' className='couon-opt' onClick={() => handleGo('/iCoupon/couponGive')}>
          <i className='iconfont icon-gift'></i>
          <span>{i18n.t('mkt.coupon.giveAway')}</span>
        </div>
        <div data-cypid='mmgToExchangeCoupon' className='couon-opt' onClick={getPromoCode}>
          <i className='iconfont icon-youhuiquan'></i>
          <span>{i18n.t('mkt.coupon.exchange')}</span>
        </div>
      </Header>
      <IonContent className='page-content'>
        <div className='page-body'>
          {(couponListForUse.length === 0 && couponType === 'my' || unacquiredCoupons.length === 0 && couponType === 'get') &&
            <div className='no-coupon-block'>
              <Empty
                msg={themeMobx?.data?.abnormalStateSetting?.[4]?.subName || ''}
                iconType='dicon'
                iconName={themeMobx?.data?.abnormalStateSetting[4]?.icon}
                picUrl={themeMobx?.data?.abnormalStateSetting[4]?.pic || noCouponImg}
                height='70vh'
                btnText={i18n.t('decoration.goMenu')}
                btnAction={() => { handleGo('/menu') }}
                btnBg={authConfigMobx.isNoWorry}
              />
            </div>}
          {
            couponListForUse.length > 0 && couponType === 'my' &&
              <>
                {
                  cashCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.cashCoupons')}</div>
                      {
                        cashCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onClick={goDetail} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  orderCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.fullDiscountCoupons')}</div>
                      {
                        orderCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onClick={goDetail} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  itemCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'>{i18n.t('mkt.coupon.itemCoupons')}</div>
                      {
                        itemCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' couponInfo={item} onClick={goDetail} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  notActiveCoupon.length > 0 &&
                    <div className='coupon-areaa'>
                      <div className='area-title'></div>
                      {
                        notActiveCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' unavailableReason={i18n.t('mkt.coupon.notActive')} couponInfo={item} onClick={goDetail} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
              </>
          }
          {unacquiredCoupons.length > 0 && couponType === 'get' && <CouponsGet onChange={() => setCouponType('my')} />}
        </div>
      </IonContent>
      <IonFooter class='page-footer'>
        <span data-cypid='mmgToCouponRecords' onClick={() => handleGo('/iCoupon/record')}>{i18n.t('mkt.coupon.couponRecord')}</span>
        <span>｜</span>
        <span data-cypid='mmgToCouponReceive' onClick={() => handleGo('/iCoupon/couponGetRecord')}>{i18n.t('mkt.coupon.couponGetRecord')}</span>
      </IonFooter>
    </IonPage>
  )
}

export default observer(CouponPage)
